<div class="e-spinner-container" [class.cursor-progress]="spinnerActive">
	<div #formSpinner [class.e-spinner-target]="spinnerActive"></div>
	<ng-content></ng-content>
</div>
